import type { Produit, StatutStock } from "./types";

export const euro = (n: number) =>
  n.toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });

export const nb = (n: number) => n.toLocaleString("fr-FR");

export const statut = (p: Produit): StatutStock =>
  p.qte <= 0 ? "rupture" : p.qte < p.seuil ? "bas" : "ok";

export const pause = (ms: number) => new Promise((r) => setTimeout(r, ms));
